import React, { useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';

function PaginationComponent({ currentPage, totalPages, onPageChange, onItemsPerPageChange }) {
    const calculateVisiblePages = () => {
        const visiblePages = [];
        const maxVisiblePages = 5;
    
        visiblePages.push(1);
    
        let startPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 2);
    
        if (endPage - startPage < maxVisiblePages - 2) {
          startPage = Math.max(2, endPage - maxVisiblePages + 2);
        }
    
        for (let i = startPage; i <= endPage; i++) {
          visiblePages.push(i);
        }
    
        return visiblePages;
      };

    const itemsPerPageOptions = [5, 10, 15];
    const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);

    const handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value);
        setItemsPerPage(newItemsPerPage);
        onItemsPerPageChange(newItemsPerPage);
    };

    return (
        <div className="d-flex justify-content-between mt-4 p-2">
            <div>
                <Pagination>
                    <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                    />
                    {calculateVisiblePages().map((number) => (
                        <Pagination.Item
                            key={number}
                            active={number === currentPage}
                            onClick={() => onPageChange(number)}
                        >
                            {number}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                    />
                </Pagination>
            </div>
            <div>
                <Form.Control
                    as="select"
                    className="form-select"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                >
                    {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                            {option} rows
                        </option>
                    ))}
                </Form.Control>
            </div>
        </div>
    );
}

export default PaginationComponent;
